import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GqlParser, QueryResult } from '@unipin/angular-gql';
import { PaymentActionResponse, QueryPgwMsInquiryActionArgs, QueryPgwMsInquiryTransactionInfoByPciRefArgs, TransactionInfo } from 'graphql/generated';
import { ShieldStore } from '@core/states/shield/shield.store';


@Injectable({
  providedIn: 'root'
})
export class WebtopupService {

  protected readonly shieldStore = inject(ShieldStore);

  constructor(
    protected readonly gql: GqlParser,
  ) { }

  public inquiry(
    queryOpts: { 
      operationName: string;
      headers?: Record<string, string>;
      variables: QueryPgwMsInquiryActionArgs;
    }, 
    extraAttr: string = ''
  ): Observable<QueryResult<{ pgwMsInquiryAction: PaymentActionResponse }>>{
    
    const { variables, operationName, headers } = queryOpts;

    variables.isShieldCalled = this.shieldStore.isShieldCalled(); 
    return this.gql.query<{ pgwMsInquiryAction: PaymentActionResponse }>(
      {
        headers,
        variables,
        operationName,
        cacheStrategy: 'no-cache',
        query: `
          query ${ operationName }($txnGuid: String!, $isShieldCalled: Boolean, $denomInput: DenomSelectionInput, $channelInput: ChannelSelectionInput, $requiredFieldInput: RequiredFieldInput) {
            pgwMsInquiryAction(txnGuid: $txnGuid, isShieldCalled: $isShieldCalled, denomInput: $denomInput, channelInput: $channelInput, requiredFieldInput: $requiredFieldInput) {
              data
              errorId
              mainAction
              message
              status
              time
              shieldSetting
              providerExternalName
              ${ extraAttr }
            }
          }
        `
      }
    ).pipe(
      tap(
        (res) => {
          const data = res.data?.pgwMsInquiryAction?.data;
          
          if (data?.action?.data?.paymentGuide) {
            let paymentGuide = data.action.data.paymentGuide;
            
            if (
              paymentGuide &&
              typeof paymentGuide === 'string'
            ) {
              data.action.data.paymentGuide = paymentGuide.replace(
                /<p><br><\/p><p><br><\/p><p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https:\/\/www\.froala\.com\/wysiwyg-editor\?pb=1" title="Froala Editor">Froala Editor<\/a><\/p>/g,
                ''
              );
            }
          }
        }
      )
    );
  }

  public inquiryTransactionStatus(variables: QueryPgwMsInquiryTransactionInfoByPciRefArgs): Observable<QueryResult<{ pgwMsInquiryTransactionInfoByPciRef: TransactionInfo }>>{
    return this.gql.query<{ pgwMsInquiryTransactionInfoByPciRef: TransactionInfo }>(
      {
        variables,
        cacheStrategy: 'no-cache',
        operationName: 'InquiryTransactionByPciRef',
        query: `
          query InquiryTransactionByPciRef($input: PciTransactionQueryCriteria!) {
            pgwMsInquiryTransactionInfoByPciRef(input: $input) {
              txnStatus
            }
          }
        `
      }
    );
  }
}
